import React, { useState, useEffect } from "react";
import Layout from "../../components/layout/Layout";
import "./playlist.css";
import SearchIcon from "@mui/icons-material/Search";
import {
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  Grid,
  Box,
  Checkbox,
  Typography,
  FormControlLabel,
  FormControl,
  CircularProgress,
  InputLabel,
  Input,
  Button,
  Menu,
  MenuItem,
  DialogActions,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Divider,
  Paper,
  IconButton,
  Select,
} from "@mui/material";
import { formatMs } from "./formatMs";
import PlaylistListView from "./components/PlaylistListView";
import PlaylistItemsPanel from "./components/PlaylistItemsPanel";
import AssignScreensDialog from "./components/AssignScreensDialog";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  addPlaylist,
  renamePlaylist,
  deletePlaylist,
  deleteContentFromPlaylist,
  updateDuration,
  getPlaylist,
  playlistFlagOff,
  updatePlaylist,
  deletePlaylistSchedule,
  playlistContentSort,
} from "../../Redux/Actions/playlistAction";
// import { DeleteOutline } from "@mui/icons-material";
// import { imgUrl } from "../../api/api";
import Tab from "../tab/Tab";
import PrimarySearchBar from "../../components/searchBar/searchbar";
// import DeleteIcon from '../../Assets/images/delete.svg';
// import { ReactComponent as DeleteIcon } from "../../Assets/images/delete.svg";
import { getScreens } from "../../Redux/Actions/screenAction";
import toast from "react-hot-toast";
import PlaylistContentCardItem from "./component/content-card/PlaylistContentCardItem";
import ScheduleSendIcon from "@mui/icons-material/ScheduleSend";
import dayjs from "dayjs";
import { getContent } from "../../Redux/Actions/contentAction";
import { PlaylistAddOutlined, CloseOutlined } from "@mui/icons-material";
import Loader from "../../components/loader/Loader";
import DeleteModel from "../../components/deletemodel/DeleteModel";
import { api } from "../../api/api";
import { ADD_CONTENT_IN_PLAYLIST, DELETE_CONTENT_FROM_PLAYLIST, DELETE_PLAYLIST, PLAYLIST_CONTNET_SORTING, PLAYLIST_SCHEDULE_DELETE, PLAYLIST_SCHEDULE_SUCCESS, PLAYLIST_TO_MULTIPLE_SCREEN_SUCCESS, UPDATE_DURATION } from "../../Redux/constant";
import _default from "react-redux/es/components/connect";
import useFilter from "../../hooks/useFilter";
import { canEditCms, canSetGlobalPlaylist, isSuperAdmin } from "../../utils/accessControl";
import { useContextUserId, useSupportContext } from "../../hooks/useSupportContext";
import { tr } from "../../i18n";
// import ScheduleSendIcon from "@mui/icons-material/ScheduleSend";
function Playlist({ auth, user, socketRef }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const canEdit = canEditCms(user);
  const canSetGlobal = canSetGlobalPlaylist(user);
  const contextUserId = useContextUserId();
  const { activeOrg } = useSupportContext();
  const {
    playlist,
    content,
    isPlaylistAdded,
    isPlaylistDeleted,
    isPlaylistUpdated,
    isPlaylistLoading,
    isPlaylistScheduled,
    isPlaylistScheduledDeleted,
    isSorted,
    type,
    _playlistId,
    isPlaylistAssign,
    pagination
  } = useSelector((state) => state.Playlist);
  const [value, setValue] = useState(dayjs("2014-08-18T21:11:54"));
  const { screens } = useSelector((state) => state.Screen);

  /** API paginates screens (default 10); use a high limit when loading screens elsewhere. */
  const [openModel, setOpenModel] = useState(false);
  const [openContentModel, setOpenContentModel] = useState(false);
  const [name, setName] = useState("");
  const [setAsGlobal, setSetAsGlobal] = useState(false);
  const [pId, setPID] = useState("");
  const [screenMac, setScreenMac] = useState("");
  const [playlistId, setPlaylistId] = useState("");
  const [macList,setMacList]=useState([]);
  const [contentId, setContentId] = useState("");
  const [openDeleteModel, setOpenDeleteModel] = useState(false);
  const [min, setMin] = useState(0);
  const [sec, setSec] = useState(0);
  const [openTimeDialoge, setOpenTimeDialoge] = useState(false);
  const [openSchedule, setOpenSchedule] = useState(false);
  const [textVal, setTextVal] = useState("");
  const [filteredPlaylist, setFilteredPlaylist] = useState([]);
  const [contentID, setContentID] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [startTime, setStartTime] = useState("");
  const [endTime, setEndTime] = useState("");
  const [day, setDay] = useState([]);
  const [isScheduled, setIsScheduled] = useState(false);
  const [scheduleInfo, setScheduleInfo] = useState({});
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [viewMode, setViewMode] = useState('list'); // 'list' or 'card'
  const [selectedPlaylist, setSelectedPlaylist] = useState(null);
  const [nameError, setNameError] = useState("");
  const [organizationOptions, setOrganizationOptions] = useState([]);
  const [selectedOrganizationIds, setSelectedOrganizationIds] = useState([]);
  const [openAssignDialog, setOpenAssignDialog] = useState(false);
  const [playlistToAssign, setPlaylistToAssign] = useState(null);
  const filtered=useFilter(textVal,playlist);
  const [days, setDays] = useState([
    { _id: 1, day: "Mon", dayChecked: false },
    { _id: 2, day: "Tue", dayChecked: false },
    { _id: 3, day: "Wed", dayChecked: false },
    { _id: 4, day: "Thu", dayChecked: false },
    { _id: 5, day: "Fri", dayChecked: false },
    { _id: 6, day: "Sat", dayChecked: false },
    { _id: 7, day: "Sun", dayChecked: false },
  ]);
  const handleChange = (newValue) => {
    setValue(newValue);
  };
  useEffect(() => {
    if (auth && contextUserId) {
      try {
        loadPlaylists();
      } catch (error) {
        console.log(error.message);
      }
    } else if (auth && !contextUserId) {
      console.error('User is authenticated but user object is missing');
      toast.error(tr("User session expired. Please log in again."));
      navigate('/login');
    } else if (!auth) {
      console.error('User is not authenticated');
      toast.error(tr("Please log in to access playlists"));
      navigate('/login');
    }
  }, [auth, contextUserId, navigate]);

  const loadPlaylists = (page = currentPage, limit = itemsPerPage, search = searchTerm) => {
    if (!contextUserId) {
      console.error('User ID is missing or invalid. Please log in first.');
      toast.error(tr("Please log in to view playlists"));
      return;
    }

    if (!auth) {
      console.error('User is not authenticated');
      toast.error(tr("Please log in to view playlists"));
      return;
    }

    dispatch(getPlaylist(contextUserId, { page, limit, search }));
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    loadPlaylists(page, itemsPerPage, searchTerm);
  };

  const handleItemsPerPageChange = (newItemsPerPage) => {
    setItemsPerPage(newItemsPerPage);
    setCurrentPage(1);
    loadPlaylists(1, newItemsPerPage, searchTerm);
  };

  const handleSearch = (search) => {
    setSearchTerm(search);
    setCurrentPage(1);
    loadPlaylists(1, itemsPerPage, search);
  };

  // ListView action handlers
  const handleEditPlaylist = (playlist) => {
    setPID(playlist._id);
    setName(playlist.name);
    setOpenModel(true);
  };

  const handleDeletePlaylist = (playlist) => {
    setPID(playlist._id);
    setOpenDeleteModel(true);
  };

  const handleSchedulePlaylist = (playlist) => {
    setPID(playlist._id);
    setScheduleInfo(playlist.schedule || {});
    setOpenSchedule(true);
  };

  // New handlers for playlist items panel
  const handlePlaylistSelect = (playlist) => {
    setSelectedPlaylist(playlist);
  };

  const handleCloseSidebar = () => {
    setSelectedPlaylist(null);
  };

  const handleAddItemToPlaylist = (playlist) => {
    if (contextUserId) {
      dispatch(getContent(contextUserId));
      dispatch(getScreens(contextUserId));
    }
    setPID(playlist._id);
    setOpenContentModel(true);
  };

  const handleUpdateItemDuration = (item, newDuration) => {
    const obj = {
      playlistId: selectedPlaylist._id,
      contentId: item._id,
      time: formatMs(newDuration),
    };
    dispatch(updateDuration(obj));
  };

  const handleRemoveItemFromPlaylist = (item) => {
    dispatch(
      deleteContentFromPlaylist({
        playlistId: selectedPlaylist._id,
        contentId: item._id,
      })
    );
  };

  const handleSortPlaylistItems = (sortedItems) => {
    // Update the selected playlist with sorted items
    const updatedPlaylist = { ...selectedPlaylist, content: sortedItems };
    setSelectedPlaylist(updatedPlaylist);
    
    // The backend expects from and to parameters, but we're sending the entire content array
    // Let's update the backend to handle the new format or modify the frontend
    // For now, let's just update the local state and dispatch with the content array
    const sortPayload = {
      playlistId: selectedPlaylist._id,
      content: sortedItems
    };
    dispatch(playlistContentSort(sortPayload));
  };

  // Alias for the component
  const handleSortItems = handleSortPlaylistItems;

  const handleAssignToMultipleScreens = (playlist) => {
    setPlaylistToAssign(playlist);
    setOpenAssignDialog(true);
  };

  const handleCloseAssignDialog = () => {
    setOpenAssignDialog(false);
    setPlaylistToAssign(null);
  };

  const handlePlayPlaylist = (playlist) => {
    const playerUrl = `/playlist-player/${playlist._id}`;
    window.open(playerUrl, "_blank");
  };


  const handleSchedulePlaylistItem = (item) => {
    // This will open the existing schedule dialog
    addSchedule(selectedPlaylist._id, item._id);
  };
  useEffect(() => {
    if (isPlaylistUpdated) {
      // toast.success("Updated successfully!");
      setIsScheduled(false);
      setFilteredPlaylist([...playlist]);
      
      // Update selected playlist if it exists
      if (selectedPlaylist) {
        const updatedPlaylist = playlist?.find(p => p?._id === selectedPlaylist?._id);
        if (updatedPlaylist) {
          setSelectedPlaylist(updatedPlaylist);
        }
      }
      
      let _playlist=playlist?.find(p=>p?._id===selectedPlaylist?._id);
       switch(type){
        case DELETE_CONTENT_FROM_PLAYLIST:
        MessageShow("Content deleted from playist."); 
        _playlist?.mac_list.forEach(m=>{
            sendEmitOnServer("event:delegate",m)
          })
          break;
          case ADD_CONTENT_IN_PLAYLIST:
           
            MessageShow("Content added in playist."); 
            _playlist?.mac_list.forEach(m=>{
              sendEmitOnServer("event:delegate",m)
            })
            break;
            case UPDATE_DURATION:
              MessageShow("Duration updated."); 
              _playlist?.mac_list.forEach(m=>{
                sendEmitOnServer("event:delegate",m)
              })  
            break;
            case PLAYLIST_SCHEDULE_SUCCESS:
              MessageShow("Schedule assigned successfully."); 
              setIsScheduled(false);
              _playlist?.mac_list.forEach(m=>{
                sendEmitOnServer("event:delegate",m);
              })  
              break;
              case PLAYLIST_SCHEDULE_DELETE:
                MessageShow("Schedule deleted successfully."); 
                setIsScheduled(false);
                _playlist?.mac_list.forEach(m=>{
                  sendEmitOnServer("event:delegate",m);
                })  
                break;
                case PLAYLIST_CONTNET_SORTING:
                  MessageShow("Content sorted."); 
                  // setIsScheduled(false);
                  _playlist?.mac_list.forEach(m=>{
                    sendEmitOnServer("event:delegate",m);
                  })  
                  break;
                  case DELETE_PLAYLIST:
                    MessageShow("Playlist deleted successfully."); 
                  // setIsScheduled(false);
                  macList?.forEach(m=>{
                    sendEmitOnServer("event:delegate",m);
                  })  
                  break;
                  case PLAYLIST_TO_MULTIPLE_SCREEN_SUCCESS:
                    let _plyalistIndex=playlist.findIndex(p=>p._id===_playlistId)
                    MessageShow("Playlist assigned to multiple screen."); 
                  // setIsScheduled(false);
                  playlist[_plyalistIndex]?.mac_list.forEach(m=>{
                    sendEmitOnServer("event:delegate",m);
                  })  
                  dispatch(playlistFlagOff());
                  break;
          default:
            break;
       }
      dispatch(playlistFlagOff());
    }
    
  }, [
    isPlaylistUpdated,
    type,
    _playlistId
  ]);
  const sendEmitOnServer=(event,mac)=>{
    socketRef.current.emit(event,{detail:{mac}})
  }
  const MessageShow=(text)=>{
    toast.success(text);
  }
  useEffect(() => {
    const loadOrganizations = async () => {
      if (!openModel || !setAsGlobal || !isSuperAdmin(user) || !contextUserId) return;
      try {
        const { data, status } = await api.get(
          `/user/getusers/${contextUserId}?orgPage=1&orgLimit=1000&usersPage=1&usersLimit=1`
        );
        if (status === 200) {
          const rows = Array.isArray(data?.sections?.organizations?.rows)
            ? data.sections.organizations.rows
            : [];
          setOrganizationOptions(rows);
        }
      } catch (error) {
        console.error("Failed to load organizations:", error);
      }
    };
    loadOrganizations();
  }, [openModel, setAsGlobal, user, contextUserId]);

  const submit = () => {
    if (!name.trim()) {
      setNameError(tr("Playlist name is required"));
      return;
    }
    setCurrentPage(1);
    if (pId) {
      dispatch(
        renamePlaylist(pId, name.trim(), contextUserId, {
          limit: itemsPerPage,
          search: searchTerm,
        })
      );
      setName("");
      setPID("");
      setNameError("");
      setOpenModel(false);
      return;
    }
    dispatch(
      addPlaylist({
        name: name.trim(),
        user: contextUserId,
        setAsGlobal,
        actorUserId: user?._id,
        organizationIds:
          isSuperAdmin(user) && setAsGlobal
            ? activeOrg
              ? [activeOrg._id]
              : selectedOrganizationIds
            : [],
        listOptions: {
          page: 1,
          limit: itemsPerPage,
          search: searchTerm,
        },
      })
    );
    setName("");
    setSetAsGlobal(false);
    setSelectedOrganizationIds([]);
    setNameError("");
    setOpenModel(false);
  };
  const addContentModel = (id, mac) => {
    if (contextUserId) {
      dispatch(getContent(contextUserId));
      dispatch(getScreens(contextUserId));
    }
    setPID(id);
    setPlaylistId(id);
    const checkingScreenAssingnation = screens.find(
      (s) => s.playlist?._id === id
    );
    // console.log("from add content model", checkingScreenAssingnation);
    if (checkingScreenAssingnation !== undefined) {
      setScreenMac(checkingScreenAssingnation.mac);
      setOpenContentModel(true);
    } else {
      setOpenContentModel(true);
    }
  };
  const deleteWholePlaylist = (id, mac) => {
    setPlaylistId(id);
    const _playlist=playlist.find(p=>p._id==id);
    setMacList([..._playlist.mac_list]);
    const checkingScreenAssingnation = screens.find(
      (s) => s.playlist?._id === id
    );
    if (checkingScreenAssingnation !== undefined) {
      setScreenMac(checkingScreenAssingnation.mac);
      setOpenDeleteModel(true);
    } else {
      setOpenDeleteModel(true);
    }
  };
  const confirmDeletePlaylist = () => {
    dispatch(deletePlaylist(pId));
    setOpenDeleteModel(false);
  };
  const deleteContent = (playlistid, contentid, screenid) => {
    setPlaylistId(playlistid)
    dispatch(
      deleteContentFromPlaylist({
        playlistId: playlistid,
        contentId: contentid,
      })
    );
    
  };
  const updateTimeHandler = (playlistid, contentid, duration, mac) => {
    setOpenTimeDialoge(true);
    setPlaylistId(playlistid);
    setContentId(contentid);
    setSec(Math.floor((duration / 1000) % 60));
  };
 
  const updateTimeConfirm = () => {
    const obj = {
      playlistId,
      contentId,
      time: `${min}:${sec}`,
    };
    setOpenTimeDialoge(false);
    dispatch(updateDuration(obj));
    setMin(0);
    setSec(0);
   
  };
  const searchHandler = (e) => {
    setTextVal(e);
    handleSearch(e);
  };
  const addSchedule = (playlistid, contentid) => {
    // console.log(playlistid,contentid)
    const info = playlist.find((p) => p._id === playlistid);
    const content = info?.content?.find((c) => c._id === contentid);
    // console.log(info, content);
    const __startDate = new Date(content?.schedule?.startDate)
      .toLocaleDateString()
      .split("/");
    const __endDate = new Date(content?.schedule?.endDate)
      .toLocaleDateString()
      .split("/");

      let _startDate=''
     let _endDate=''
     const obj={
      start:{
        year:'',
        month:'',
        day:''
      },
      end:{
        year:'',
        month:'',
        day:''
      }
     }
      if(Number(__startDate[0]) < 10){
        obj.start.month=`0${__startDate[0]}`
     
     }
     else{
      obj.start.month=__startDate[0]
     }
      if( Number(__startDate[1]) < 10){
        obj.start.day=`0${__startDate[1]}`
     
     }else{
      obj.start.day=__startDate[1]
     }
  

     if(Number(__endDate[0]) < 10) {
      obj.end.month=`0${__endDate[0]}`
     
     }else{
      obj.end.month=__endDate[0]
     }
      if(Number(__endDate[1]) < 10){
     obj.end.day=`0${__endDate[1]}`
      
     }else{
      obj.end.day=__endDate[1]
     }
  
    _startDate=`${__startDate[2]}-${obj.start.month}-${obj.start.day}`
    _endDate=`${__endDate[2]}-${obj.end.month}-${obj.end.day}`
   
    if (content?.schedule?.scheduled) {
      setIsScheduled(true);
      // console.log("inside condition=>", info);
    }
    setPlaylistId(playlistid);
    setContentID(contentid);
    setStartDate(_startDate);
    setEndDate(_endDate);
    setStartTime(content?.schedule?.startTime);
    setEndTime(content?.schedule?.endTime);
    setOpenSchedule(true);
    const dbDay = content?.schedule?.days;
    // console.log(dbDay)
    const sameArray = days.filter(
      (item) => !dbDay.find((d) => d.day === item.day)
    );
    // console.log([...sameArray,...dbDay]);
    setDays([...sameArray, ...dbDay]);
    setDay([...dbDay]);
  };
const cleaner=()=>{
  setDay([]);
  setDays([
    { _id: 1, day: "Mon", dayChecked: false },
    { _id: 2, day: "Tue", dayChecked: false },
    { _id: 3, day: "Wed", dayChecked: false },
    { _id: 4, day: "Thu", dayChecked: false },
    { _id: 5, day: "Fri", dayChecked: false },
    { _id: 6, day: "Sat", dayChecked: false },
    { _id: 7, day: "Sun", dayChecked: false },
  ]);
  setOpenSchedule(false);
  setIsScheduled(false);
}
  const saveSchedule = () => {
    // console.log(day,playlistId,contentID);
    dispatch(
      updatePlaylist(playlistId, contentID, {
        startDate,
        endDate,
        startTime,
        endTime,
        days: day,
      })
    );
   cleaner();
  };
  const deleteScheduleFromPlaylist = (pid, cid) => {
    cleaner();
    dispatch(deletePlaylistSchedule(pid, cid));
  };
  const cancelSchedule = () => {
    cleaner();
  };
  const handleDayCheckbox = (e) => {
    const { name, checked, value } = e.target;
    // console.log(name,checked,value,days)
    if (checked) {
      setDay((prev) => [...prev, { day: value, dayChecked: true }]);
      const selectedDayIndex = days.findIndex((d) => d._id == name);
      days[selectedDayIndex] = { ...days[selectedDayIndex], dayChecked: true };
      setDays([...days]);
      // console.log(selectedDayIndex)
    } else {
      setDay((prev) => [...day.filter((d) => d.day !== value)]);
      const selectedDayIndex = days.findIndex((d) => d._id == name);
      days[selectedDayIndex] = { ...days[selectedDayIndex], dayChecked: false };
      // console.log(selectedDayIndex)
      setDays([...days]);
    }
    // console.log('days array=>',days)
  };
  
  // Show loading or redirect if not authenticated
  if (!auth) {
    return <Loader />;
  }

  if (auth && !user?._id) {
    return <Loader />;
  }

  return (
    <>
      <Layout title={tr("Playlist")} user={user}>
        <div className={`parent-container${selectedPlaylist ? " playlist-split-active" : ""}`}>
          <Paper
            elevation={0}
            className="playlist-toolbar"
            sx={{
              display: "flex",
              flexWrap: "wrap",
              alignItems: "center",
              gap: "14px",
              padding: "12px 20px",
              borderRadius: "14px",
              border: "1px solid #E5E7EB",
              backgroundColor: "#fff",
              mb: "4px",
            }}
          >
            <div className="toolbar-search">
              <PrimarySearchBar value={textVal} onChange={searchHandler} />
            </div>
            {canEdit && (
              <div className="toolbar-actions">
                <button
                  className="toolbar-btn toolbar-btn--primary"
                  onClick={() => {
                    setPID("");
                    setName("");
                    setOpenModel(true);
                  }}
                >
                  {tr("+ Create Playlist")}
                </button>
              </div>
            )}
          </Paper>

          <Grid container spacing={2} sx={{ mt: "4px", width: "100%", minWidth: 0 }}>
            {isPlaylistLoading ? (
              <Grid item xs={12}>
                <Box sx={{ display: "flex", justifyContent: "center", py: 8 }}>
                  <Loader />
                </Box>
              </Grid>
            ) : (
              <>
                <Grid item xs={12} md={selectedPlaylist ? 6 : 12} sx={{ minWidth: 0 }}>
                  <PlaylistListView
                    playlists={filtered}
                    onSelect={handlePlaylistSelect}
                    onDelete={handleDeletePlaylist}
                    onAssignToScreens={handleAssignToMultipleScreens}
                    onEdit={handleEditPlaylist}
                    onSchedule={handleSchedulePlaylist}
                    onPlay={handlePlayPlaylist}
                    selectedPlaylist={selectedPlaylist}
                    pagination={pagination}
                    onPageChange={handlePageChange}
                    onRowsPerPageChange={(e) => handleItemsPerPageChange(parseInt(e.target.value, 10))}
                    readOnly={!canEdit}
                  />
                </Grid>
                {selectedPlaylist && (
                  <Grid item xs={12} md={6} sx={{ minWidth: 0 }}>
                    <PlaylistItemsPanel
                      selectedPlaylist={selectedPlaylist}
                      onClose={handleCloseSidebar}
                      onUpdateDuration={handleUpdateItemDuration}
                      onRemoveItem={handleRemoveItemFromPlaylist}
                      onSortItems={handleSortItems}
                      onAddItem={handleAddItemToPlaylist}
                      readOnly={!canEdit}
                    />
                  </Grid>
                )}
              </>
            )}
          </Grid>
        </div>
      </Layout>

      <Dialog
        sx={{ zIndex: "10000000000000" }}
        open={openSchedule}
        onClose={cancelSchedule}
       fullWidth
      >
        <DialogTitle
          style={{
            textAlign: "center",
            fontSize: "18px",
            fontWeight: "700",
            marginBottom: "30px",
            // paddingBottom: '18px',
            borderBottom: "3px solid #008080",
          }}
        >
          <ScheduleSendIcon sx={{ color: "#008080" }} /> {tr("Schedule")}
        </DialogTitle>
        <DialogContent>
          <Box
            sx={{
              minHeight: "50vh",
              width: {xl:"30dvw",lg:'30dvw',md:'30dvw',sm:'100dvw',xs:'100dvw'},
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Box
              sx={{
                height: "97%",
                width: "97%",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Box
                sx={{
                  height: "20%",
                  width: "100%",
                  display: "flex",
                  gap: "10px",
                  border: "1px solid transparent",
                }}
              >
                <Box sx={{ flex: 1 }}>
                  <InputLabel htmlFor="start-date">{tr("Start Date")}</InputLabel>
                  <TextField
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                    id={"start-date"}
                    type={"date"}
                    fullWidth
                  />
                </Box>

                <Box sx={{ flex: 1 }}>
                  <InputLabel htmlFor="end-date">{tr("End Date")}</InputLabel>
                  <TextField
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                    id={"end-date"}
                    type={"date"}
                    fullWidth
                  />
                </Box>
              </Box>

              <Box
                sx={{
                  height: "20%",
                  width: "100%",
                  display: "flex",
                  gap: "10px",
                  border: "1px solid transparent",
                }}
              >
                <Box sx={{ flex: 1 }}>
                  <InputLabel htmlFor="start-time">{tr("Start Time")}</InputLabel>
                  <TextField
                    value={startTime}
                    onChange={(e) => setStartTime(e.target.value)}
                    id={"start-time"}
                    type={"time"}
                    fullWidth
                  />
                </Box>

                <Box sx={{ flex: 1 }}>
                  <InputLabel htmlFor="end-time">{tr("End Time")}</InputLabel>
                  <TextField
                    value={endTime}
                    onChange={(e) => setEndTime(e.target.value)}
                    id={"end-time"}
                    type={"time"}
                    fullWidth
                  />
                </Box>
              </Box>

              <Box
                id={"days-id"}
               className="days-wrapper"
              >
                {days.map((d, index) => {
                  return (
                    <>
                      <input
                        onChange={handleDayCheckbox}
                        name={d._id}
                        value={d.day}
                        checked={d.dayChecked ? true : false}
                        type={"checkbox"}
                        id={`day-${index}`}
                        style={{ display: "none" }}
                      />
                      <label
                        htmlFor={`day-${index}`}
                        className="label-btn"
                      >
                        {d.day}
                      </label>
                    </>
                  );
                })}
              </Box>

              <Box
                sx={{
                  minHeight: "20%",
                  margin: "10px 0",
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexWrap: "wrap",
                  gap: "5px",
                }}
              >
                <Button
                  variant={"outlined"}
                  type="button"
                  sx={{
                    width: "100px",
                    color: "#008080",
                    border: "1px solid #008080",
                  }}
                  onClick={cancelSchedule}
                >
                  {tr("Cancel")}
                </Button>
                <Button
                  variant={"contained"}
                  type="button"
                  className="schedule-save-btn"
                  onClick={saveSchedule}
                >
                  {tr("Save")}
                </Button>
                {isScheduled ? (
                  <>
                    <Button
                      variant="contained"
                      color={"error"}
                      onClick={() =>
                        deleteScheduleFromPlaylist(playlistId, contentID)
                      }
                    >
                      {tr("Delete")}
                    </Button>
                  </>
                ) : (
                  <></>
                )}
              </Box>
            </Box>
          </Box>
        </DialogContent>
      </Dialog>

      <Dialog
        open={openModel}
        onClose={() => {
          setOpenModel(false);
          setNameError("");
          setSetAsGlobal(false);
          setSelectedOrganizationIds([]);
        }}
        maxWidth="xs"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: "16px",
            overflow: "hidden",
            fontFamily: "'Electrolize', sans-serif",
          },
        }}
      >
        <DialogContent sx={{ p: 0 }}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              pt: 4,
              pb: 3.5,
              px: 4,
            }}
          >
            <Box
              sx={{
                position: "absolute",
                top: 12,
                right: 12,
              }}
            >
              <IconButton
                size="small"
                onClick={() => {
                  setOpenModel(false);
                  setNameError("");
                  setSetAsGlobal(false);
                  setSelectedOrganizationIds([]);
                }}
              >
                <CloseOutlined sx={{ fontSize: 20, color: "#9CA3AF" }} />
              </IconButton>
            </Box>

            <Box
              sx={{
                width: 64,
                height: 64,
                borderRadius: "50%",
                backgroundColor: "#F0FDFA",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                mb: 2,
              }}
            >
              <PlaylistAddOutlined sx={{ fontSize: 32, color: "#008080" }} />
            </Box>

            <Typography
              sx={{
                fontFamily: "'Electrolize', sans-serif",
                fontWeight: 600,
                fontSize: "18px",
                color: "#111827",
                mb: 0.5,
              }}
            >
              {pId ? tr("Edit Playlist") : tr("Create Playlist")}
            </Typography>

            <Typography
              sx={{
                fontFamily: "'Electrolize', sans-serif",
                fontSize: "13px",
                color: "#6B7280",
                mb: 3,
              }}
            >
              {pId ? tr("Update the playlist name") : tr("Give your playlist a name to get started")}
            </Typography>

            <TextField
              variant="outlined"
              value={name}
              onChange={(e) => { setName(e.target.value); setNameError(""); }}
              placeholder={tr("Enter playlist name")}
              fullWidth
              required
              error={!!nameError}
              helperText={nameError}
              autoFocus
              onKeyDown={(e) => e.key === "Enter" && submit()}
              sx={{
                mb: 3,
                "& .MuiOutlinedInput-root": {
                  borderRadius: "10px",
                  fontFamily: "'Electrolize', sans-serif",
                  fontSize: "14px",
                  "& fieldset": { borderColor: "#E5E7EB" },
                  "&:hover fieldset": { borderColor: "#D1D5DB" },
                  "&.Mui-focused fieldset": { borderColor: "#008080" },
                },
                "& .MuiFormHelperText-root": {
                  fontFamily: "'Electrolize', sans-serif",
                },
              }}
            />

            {!pId && canSetGlobal && (
              <>
                <FormControlLabel
                  sx={{ alignSelf: "flex-start", mb: 2 }}
                  control={
                    <Checkbox
                      checked={setAsGlobal}
                      onChange={(e) => {
                        const checked = e.target.checked;
                        setSetAsGlobal(checked);
                        if (!checked) setSelectedOrganizationIds([]);
                      }}
                      color="primary"
                    />
                  }
                  label={
                    <Typography sx={{ fontSize: "13px", color: "#374151" }}>
                      {isSuperAdmin(user)
                        ? tr("Set as global playlist")
                        : tr("Set as organization global playlist (plays on all screens in your organization)")}
                    </Typography>
                  }
                />
                {setAsGlobal && isSuperAdmin(user) && (
                  <FormControl fullWidth sx={{ mb: 2 }}>
                    <InputLabel id="global-org-select-label">{tr("Organizations")}</InputLabel>
                    <Select
                      labelId="global-org-select-label"
                      multiple
                      value={selectedOrganizationIds}
                      label={tr("Organizations")}
                      onChange={(e) => setSelectedOrganizationIds(e.target.value)}
                      renderValue={(selected) => {
                        const names = organizationOptions
                          .filter((org) => selected.includes(org._id))
                          .map((org) => org.username || org.email || org._id);
                        return names.length
                          ? names.join(", ")
                          : "All organizations (leave empty)";
                      }}
                    >
                      {organizationOptions.map((org) => (
                        <MenuItem key={org._id} value={org._id}>
                          <Checkbox checked={selectedOrganizationIds.indexOf(org._id) > -1} />
                          <ListItemText
                            primary={org.username || org.email || "Organization"}
                            secondary={org.email || ""}
                          />
                        </MenuItem>
                      ))}
                    </Select>
                    <Typography sx={{ fontSize: "12px", color: "#6B7280", mt: 0.5 }}>
                      {tr("Select one or more organizations. Leave empty to apply to all organizations.")}
                    </Typography>
                  </FormControl>
                )}
              </>
            )}

            <Box sx={{ display: "flex", gap: "12px", width: "100%" }}>
              <button
                onClick={() => {
                  setOpenModel(false);
                  setNameError("");
                  setSetAsGlobal(false);
                  setSelectedOrganizationIds([]);
                }}
                style={{
                  flex: 1,
                  height: "40px",
                  background: "white",
                  color: "#374151",
                  border: "1px solid #D1D5DB",
                  borderRadius: "8px",
                  fontSize: "14px",
                  fontWeight: 500,
                  fontFamily: "'Electrolize', sans-serif",
                  cursor: "pointer",
                }}
              >
                {tr("Cancel")}
              </button>
              <button
                onClick={submit}
                style={{
                  flex: 1,
                  height: "40px",
                  background: "#008080",
                  color: "white",
                  border: "none",
                  borderRadius: "8px",
                  fontSize: "14px",
                  fontWeight: 500,
                  fontFamily: "'Electrolize', sans-serif",
                  cursor: "pointer",
                }}
              >
                {pId ? tr("Update") : tr("Create")}
              </button>
            </Box>
          </Box>
        </DialogContent>
      </Dialog>

      <Dialog
        fullWidth
        maxWidth={false}
        open={openContentModel}
        onClose={() => setOpenContentModel(false)}
        sx={{
          zIndex: "10000000000",
        }}
        PaperProps={{
          className: "playlist-add-content-dialog",
          sx: {
            width: { xs: "100%", sm: "96vw", md: "92vw", lg: "88vw" },
            maxWidth: "1320px",
            maxHeight: "92vh",
            m: { xs: 1, sm: 2 },
            display: "flex",
            flexDirection: "column",
          },
        }}
      >
        <DialogTitle
          sx={{
            borderBottom: "5px solid #008080",
            textAlign: "center",
            flexShrink: 0,
            py: 1.5,
          }}
        >
          {tr("Add Content")}
        </DialogTitle>
        <DialogContent className="playlist-add-content-dialog__body">
          <Tab
            pId={pId}
            screenMac={screenMac}
            socketRef={socketRef}
            close={(a) => setOpenContentModel(a)}
          />
        </DialogContent>
      </Dialog>

      <Dialog
    
        sx={{
          // maxWidth: '20vw',
          // height: '30vh'
          zIndex: "100000000",
        }}
        open={openTimeDialoge}
        onClose={() => setOpenTimeDialoge(false)}
        fullWidth
      >
        <DialogTitle
          sx={{
            fontWeight: "700",
            fontSize: "18px",
            borderBottom: "2px solid #008080",
            mb: 2,
            display: "flex",
            justifyContent: "center",
          }}
        >
          {tr("Time Duration")}
        </DialogTitle>
        <DialogContent>
          <Box
            sx={{
              display: "flex",
              gap: "2px",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              width:{xl:'30dvw',lg:'30dvw',md:'30dvw',sm:'50dvw',xs:'50dvw'}
            }}
          >
            <Typography
              sx={{
                color: "#92959E",
              }}
            >
              {tr("Are you sure to Update Time?")}
            </Typography>

            <Box sx={{ display: "flex", mt: 5, width: "90%" }}>
              <TextField
                variant={"standard"}
                type="number"
                value={sec}
                onChange={(e) => setSec(e.target.value)}
                fullWidth
              />
            </Box>

            <Box
              sx={{
                display: "flex",
                mt: 5,
                width:'90%'
              }}
            >
              <button
                
                onClick={() => setOpenTimeDialoge(false)}
                className="btn danger btn-no-time-duration"
              >
                {tr("No")}
              </button>
              <button
                onClick={updateTimeConfirm}
                className="btn primary btn-update-time-duration"
              >
                {tr("Update")}
              </button>
            </Box>
          </Box>
        </DialogContent>
      </Dialog>

      <DeleteModel
        open={openDeleteModel}
        onClose={setOpenDeleteModel}
        onConfirm={confirmDeletePlaylist}
        title={tr("Delete Playlist")}
        message="Are you sure you want to delete this playlist? All items and assignments will be removed. This action cannot be undone."
      />

      <AssignScreensDialog
        open={openAssignDialog}
        onClose={handleCloseAssignDialog}
        playlist={playlistToAssign}
        userId={contextUserId}
        onAssigned={() => loadPlaylists()}
      />
    </>
  );
}

export default Playlist;
